module.exports = __webpack_public_path__ + "img/blue-footer.aea44721.png";